import React, { useEffect, useState } from 'react';
import apiClient from '../api';
import {
    Box, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    Chip, CircularProgress, Alert,
} from '@mui/material';
import moment from 'jalali-moment';
import { CONTRACT_LABELS, SHIFT_LABELS, REQUEST_STATUS_LABELS } from '../labels';
import { glass } from '../theme';

const STATUS_COLORS = { pending: 'default', active: 'primary', completed: 'success', cancelled: 'error' };

function AdminRequests() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        apiClient.get('/api/admin-panel/requests/')
            .then((res) => setRequests(res.data))
            .catch(() => setError('خطا در دریافت لیست درخواست‌ها.'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
    }

    return (
        <Box>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>درخواست‌ها</Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }}>
                آخرین {requests.length.toLocaleString('fa-IR')} درخواست ثبت‌شده در پلتفرم.
            </Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box sx={{ ...glass.card, overflow: 'auto' }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>شماره</TableCell>
                            <TableCell>خدمات</TableCell>
                            <TableCell>نوع قرارداد</TableCell>
                            <TableCell>شیفت</TableCell>
                            <TableCell>تاریخ شروع</TableCell>
                            <TableCell>پیشنهادها</TableCell>
                            <TableCell>وضعیت</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {requests.map((r) => (
                            <TableRow key={r.id} hover>
                                <TableCell>#{r.id}</TableCell>
                                <TableCell>{r.services?.map((s) => s.name).join('، ') || '—'}</TableCell>
                                <TableCell>{CONTRACT_LABELS[r.contract_type] || r.contract_type}</TableCell>
                                <TableCell>{SHIFT_LABELS[r.shift_type] || r.shift_type}</TableCell>
                                <TableCell>{moment(r.start_date).locale('fa').format('D MMMM YYYY')}</TableCell>
                                <TableCell>{r.bids?.length || 0}</TableCell>
                                <TableCell>
                                    <Chip size="small" label={REQUEST_STATUS_LABELS[r.status] || r.status} color={STATUS_COLORS[r.status] || 'default'} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
}

export default AdminRequests;
